import sanitizeHtml from 'sanitize-html';

export function formatTextWithNewLines (text, allowedTags = []) {
    return sanitizeHtml(text, {
        allowedTags,
        allowedAttributes: {
            a: ['href', 'target', 'rel', 'nofollow', 'noopener', 'noreferrer'],
        },
        disallowedTagsMode: 'recursiveEscape',
    }).replace(/\n/g, '<br />');
}
